import React, { useEffect, useState } from 'react';
import { Button, List, message } from 'antd';
import ProTable from '@ant-design/pro-table';
import {
  getWeekPerformList,
  queryPromotionList,
  sendMiniLink,
  getUserNewestFitnessReportResponse,
} from '@/services/wechat';
import { miniAppid } from '@/utils/utils';
import moment from 'moment';

import styles from '../index.less';

const Report = ({ report, dispatch }) => {
  const [reportLoading, setReportLoad] = useState(false);

  const [planLoading, setPlanLoad] = useState(false);

  const [promoteLoading, setPromoteLoad] = useState(false);

  const [total, setTotal] = useState(0);

  const [disabled, setDisabled] = useState(true);

  const { reportList, planList, promoteList, baseData, updateCount, mineInfo } =
    report;
  const columns = [
    {
      title: '推广名称',
      dataIndex: 'pageName',
    },
    {
      title: '操作',
      search: false,
      render: (text, record) => [
        <Button
          type="link"
          onClick={() => {
            sendMini(1, {
              title: record.shareDesc,
              imgUrl: record.coverImage,
              channel: baseData.channelCode,
              dmId: record.id,
            });
          }}
          key={record.id}
        >
          发送
        </Button>,
      ],
    },
  ];

  const init = () => {
    if (!report.customerInfo.customerId) {
      return message.error({
        content: '没有获取到内部id',
        duration: 1,
      });
    }
    setDisabled(false);
    // 获取体测报告list
    getReportList();
    // 获取训练计划list
    getPlanList();
    // 获取推广页table
    // queryPromoteList();
  };

  const getReportList = async () => {
    setReportLoad(true);
    const { data, msg, code } = await getUserNewestFitnessReportResponse({
      requestData: {
        innerUserId: report.customerInfo.customerId,
      },
    });
    setReportLoad(false);

    if (code !== '00000') {
      message.error(msg);
    } else {
      if (data) {
        dispatch({
          type: 'report/saveReportList',
          payload: {
            data: [data],
          },
        });
      }
    }
  };
  const getPlanList = async () => {
    setPlanLoad(true);
    const { data, msg, code } = await getWeekPerformList({
      requestData: {
        innerUserId: report.customerInfo.customerId,
      },
      page: {
        currentPage: 0,
        pageSize: 100,
      },
    });
    setPlanLoad(false);
    if (code === '00000') {
      if (data) {
        dispatch({
          type: 'report/saveWeekPlanList',
          payload: {
            data,
          },
        });
      }
    } else {
      message.error(msg);
    }
  };
  const queryPromoteList = async (params = {}) => {
    const { pageSize, current } = params;
    setPromoteLoad(true);
    const { msg, code, data, page } = await queryPromotionList({
      requestData: {
        status: 1, // 默认筛选上架状态
      },
      page: {
        pageSize,
        currentPage: current,
      },
    });
    setPromoteLoad(false);
    if (code !== '00000') {
      message.error(msg);
    } else {
      dispatch({
        type: 'report/savePromoteList',
        payload: { data },
      });
      setTotal(page.count);
    }
  };

  const sendMini = async (type, params) => {
    const { code, msg, data } = await sendMiniLink({
      type,
    });
    if (code === '00000') {
      console.log('开始调用sendChatMessage:');
      let title, imgUrl, page;
      if (type === 1) {
        title = params.title || data.content;
        imgUrl = params.imgUrl || data.imageUrls[0];
        page = `/packageA/pages/coach/coursePay.html?channel=${params.channel}&saleId=${mineInfo?.userId}&id=${params.dmId}`;
      }
      if (type === 2) {
        title = data.content;
        imgUrl = data.imageUrls[0];
        page = `/packageD/report/index.html?id=${params.id}`;
      }
      wxMiniSendSdk(title, imgUrl, page);
    } else {
      message.error(msg);
    }
  };

  const wxMiniSendSdk = (title, imgUrl, page) => {
    wx.invoke(
      'sendChatMessage',
      {
        msgtype: 'miniprogram',
        enterChat: true,
        miniprogram: {
          appid: miniAppid,
          title,
          imgUrl,
          page, //文本内容
        },
      },
      function (res) {
        if (res.err_msg !== 'sendChatMessage:ok') {
          message.error(res.err_msg);
        }
      },
    );
  };

  useEffect(() => {
    init();
  }, [updateCount]);

  const getPlanStatus = (status) => {
    const statusList = ['未履约', '履约中', '已履约'];
    return statusList[status];
  };

  const toPage = (page, data) => {
    dispatch({
      type: 'report/changePage',
      payload: {
        page,
        data,
      },
    });
  };

  return (
    <div className={styles.reportPlan}>
      <List
        loading={reportLoading}
        style={{ marginBottom: '20px', maxHeight: 300, overflowY: 'scroll' }}
        header={
          <div className={styles.cervix}>
            <span className={styles.reportPlanTitle}>体测报告</span>
            <Button
              disabled={disabled}
              type="link"
              onClick={() =>
                toPage(3, {
                  classOrder: 'report',
                })
              }
            >
              约课
            </Button>
          </div>
        }
        bordered
        dataSource={reportList}
        renderItem={(item, index) => (
          <List.Item>
            <div className={styles.reportBox}>
              {`体测报告（${moment(item.ctime).format('YYYY-MM-DD')}）`}
              <div>
                <Button
                  type="link"
                  onClick={() => {
                    dispatch({
                      type: 'report/queryReportDetail',
                      payload: {
                        reportId: item.id,
                        innerUserId: report.customerInfo.customerId,
                      },
                    });
                  }}
                >
                  查看
                </Button>
                <Button
                  type="link"
                  onClick={() => {
                    sendMini(2, {
                      id: item.id,
                    });
                  }}
                >
                  发送
                </Button>
              </div>
            </div>
          </List.Item>
        )}
      />
      <List
        style={{ marginBottom: '20px', maxHeight: 300, overflowY: 'scroll' }}
        loading={planLoading}
        header={
          <div className={styles.cervix}>
            <span className={styles.reportPlanTitle}>训练计划</span>
            <Button
              disabled={disabled}
              type="link"
              onClick={() =>
                toPage(3, {
                  classOrder: 'plan',
                })
              }
            >
              约课
            </Button>
          </div>
        }
        bordered
        dataSource={planList}
        renderItem={(item) => (
          <List.Item>
            <div className={styles.reportBox}>
              第{item.weekNo}周训练计划
              <div>
                <span style={{ marginRight: 10 }}>
                  {getPlanStatus(item.perfomStatus)}
                </span>
                <Button
                  type="link"
                  onClick={() => {
                    dispatch({
                      type: 'report/queryPlanDetail',
                      payload: {
                        weekNo: item.weekNo,
                        innerUserId: report.customerInfo.customerId,
                        toPage: true,
                      },
                    });
                  }}
                >
                  查看
                </Button>
              </div>
            </div>
          </List.Item>
        )}
      />
      <div className={styles.reportPromotion}>
        <div className={styles.reportPlanTitle}>推广页</div>
        <div></div>
        <ProTable
          columns={columns}
          dataSource={promoteList}
          rowKey="id"
          bordered
          loading={promoteLoading}
          request={queryPromoteList}
          pagination={{
            defaultPageSize: 5,
            total,
          }}
        />
      </div>
    </div>
  );
};

export default Report;
